<template>
  <div
    v-if="display"
    class="fade-away-message-container rounded-lg elevation-1 d-inline-flex justify-space-between align-center"
    :class="{
      show: showClass,
      hide: !showClass,
      variation1: showVariation1Class,
      variation2: showVariation2Class,
      variation3: showVariation3Class,
      variation4: showVariation4Class,
      variation5: showVariation5Class,
    }"
    :style="{
      top: top + '%',
      'min-height': header && message ? '100px' : '60px',
      maxWidth: width + 'px',
      width: '90%',
    }"
  >
    <div class="icon-container pa-2 d-flex" v-if="displayType == 'variation2'">
      <div class="left-line" :class="background"></div>
      <v-icon :class="background" class="icon">{{ mdiIcon }}</v-icon>
    </div>
    <div class="icon-container pa-2" :class="background" v-else>
      <v-icon class="icon mx-0">{{ mdiIcon }}</v-icon>
    </div>
    <div class="message-container pa-2">
      <div class="title-message-wrapper">
        <div :class="headerClasses" v-if="header">{{ header }}</div>
        <div
          class="message"
          style="color:black; font-weight: 500;"
          v-if="message"
        >
          {{ message }}
        </div>
      </div>
    </div>
    <div class="close-container pa-2 d-flex align-center justify-center">
      <v-btn id="fadeawayclose" fab small text @click="clickClose">
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "FadeAwayMessage",
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    header: {
      type: String,
      default: "SERVER ERROR",
    },
    message: {
      type: String,
      default: "Something went wrong!",
    },
    timeout: {
      type: [Number, String],
      default: 1500,
    },
    type: {
      type: String,
      default: "success",
    },
    top: {
      type: [Number, String],
      default: 20,
    },
    backgroundClass: {
      type: String,
      default: "primary",
    },
    textColorClass: {
      type: String,
      default: "white--text",
    },
    displayType: {
      type: String,
      default: "default",
    },
    width: {
      type: [Number, String],
      default: 600,
    },
  },

  watch: {
    type: function(val) {
      this.setType(val);
    },

    value: function(val) {
      this.display = val;
    },

    display: function(val) {
      if (val) {
        this.showBox();
      } else {
        this.clickClose();
      }
    },
  },

  mounted: function() {
    this.display = this.value;
  },

  data: () => ({
    display: false,
    mdiIcon: "mdi-check",
    background: "teal darken-3",
    headerClasses: "title",
    mainContainerClasses: {},

    showClass: false,
    showVariation1Class: false,
    showVariation2Class: false,
    showVariation3Class: false,
    showVariation4Class: false,
    showVariation5Class: false,
  }),

  methods: {
    showBox: function() {
      this.$emit("input", true);
      this.headerClasses = "title";
      if (this.message && this.header) {
        this.headerClasses += " mb-2 ";
      }

      this.setType();
      this.setMainContainerClass();

      setTimeout(() => {
        this.showClass = true;
        setTimeout(() => {
          this.clickClose();
        }, this.timeout);
      }, 10);
    },

    clickClose: function() {
      this.showClass = false;

      setTimeout(() => {
        this.display = false;
        this.$emit("input", false);
      }, 1000);
    },

    setMainContainerClass: function() {
      this.showVariation1Class = false;
      this.showVariation2Class = false;
      this.showVariation3Class = false;
      this.showVariation4Class = false;
      this.showVariation5Class = false;

      switch (this.displayType) {
        case "variation1":
          this.showVariation1Class = true;
          break;
        case "variation2":
          this.showVariation2Class = true;
          break;
        case "variation3":
          this.showVariation3Class = true;
          break;
        case "variation4":
          this.showVariation4Class = true;
          break;
        case "variation5":
          this.showVariation5Class = true;
          break;
      }
    },

    setType: function(type) {
      switch (type) {
        case "success":
        case "primary":
          this.background = "primary";
          this.mdiIcon = "mdi-check";
          break;
        case "warning":
          this.background = "amber";
          this.mdiIcon = "mdi-alert-circle-outline";
          break;
        case "danger":
        case "error":
          this.background = "error";
          this.mdiIcon = "mdi-alert-octagon-outline";
          break;
      }
    },
  },
};
</script>

<style scoped>
/* ── Base (desktop) ── */
.fade-away-message-container {
  position: fixed;
  top: 20%;
  width: 90%;
  max-width: 600px;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fefefe;
  border-radius: 5px;
  z-index: 9999;
  min-height: 60px;
  overflow: hidden;
  transition: opacity 0.4s ease;
  opacity: 0;

  /* keep children in a row on desktop */
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fade-away-message-container.show {
  opacity: 1;
}
.fade-away-message-container.hide {
  opacity: 0;
}

/* ── Icon container ── */
.icon-container {
  flex-shrink: 0;
  width: 20%;
  min-width: 56px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch; /* fill full height of the card */
}

.icon {
  font-size: 40px;
}

/* ── Message area ── */
.message-container {
  flex: 1;
  min-width: 0; /* allows text to shrink & wrap */
}

.message-container .title-message-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.message-container .message,
.message-container .title {
  line-height: 1.4;
  word-break: break-word;
  white-space: normal;
}

/* ── Close button ── */
.close-container {
  flex-shrink: 0;
  width: 48px;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-container button i {
  color: #ababab !important;
}

/* ── Typography ── */
.title {
  font-size: 14px !important;
  letter-spacing: 0px !important;
  color: rgb(31, 30, 30) !important;
  font-weight: 600;
  font-family: "Arimo", sans-serif !important;
}

/* ── Variation 1 ── */
.variation1 .icon-container {
  width: 17%;
}
.variation1 .icon-container .icon {
  font-size: 35px;
  color: #fff;
}
.variation1 .title-message-wrapper {
  padding: 0 30px;
}
.variation1 .message {
  color: #666;
}
.variation1 .message,
.variation2 .message {
  font-weight: lighter;
  font-size: 13px;
  letter-spacing: 0.8px;
  color: #959595;
}
.variation1 .close-container button {
  background-color: #fff !important;
}
.variation1 .close-container button i {
  font-size: 18px;
}

/* ── Variation 2 ── */
.variation2 {
  padding: 0;
}
.left-line {
  width: 6px;
  align-self: stretch;
}
.variation2 .icon-container {
  padding: 0 !important;
}
.variation2 .icon-container i {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  font-size: 25px;
  color: #fff;
  margin: 0 15px;
}
.variation2 .title-message-wrapper {
  padding: 0 10px;
}
.variation2 .close-container button {
  background-color: #fff !important;
}

/* ── Mobile (≤ 600 px) ── */
@media (max-width: 600px) {
  .fade-away-message-container {
    /* push down from the very top so it doesn't overlap status bar */
    top: 12px !important;
    transform: translateX(-50%) !important;

    flex-direction: row; /* keep icon | text | ✕ in one row */
    align-items: center;
    width: calc(100% - 24px); /* 12 px margin on each side */
    max-width: 100%;
    padding: 8px 4px;
    border-radius: 10px;
  }

  /* Shrink icon column on small screens */
  .icon-container {
    width: 44px;
    min-width: 44px;
  }

  .icon {
    font-size: 26px;
  }

  /* Make close button a comfortable tap target */
  .close-container {
    width: 40px;
    min-width: 40px;
  }

  /* Variation 1 adjustments */
  .variation1 .icon-container {
    width: 44px;
    min-width: 44px;
  }
  .variation1 .title-message-wrapper {
    padding: 0 8px;
  }

  /* Variation 2 adjustments */
  .variation2 .icon-container i {
    width: 30px;
    height: 30px;
    font-size: 18px;
    margin: 0 8px;
  }
  .variation2 .title-message-wrapper {
    padding: 0 6px;
  }

  /* Typography on mobile */
  .message {
    font-size: 13px !important;
  }

  .title {
    font-size: 13px !important;
  }
}
</style>
